module.exports = __webpack_public_path__ + "img/state_2.31ce8142.jpg";